import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import * as $ from 'jquery';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public modalRef: BsModalRef;
  user: any;
  config = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'logoutModal'
  };
  
  constructor(private router : Router, private modalService: BsModalService) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
  }

  //expanding hamburger button
  expandMenu(){
    var x = document.getElementById('myTopnav');
    if (x.className === 'topnav') {
        x.className += ' responsive';
    } else {
        x.className = 'topnav';
    }
  }

  logout(modalData){
    this.modalRef = this.modalService.show(modalData, this.config);          
  }

  ok(){
    this.modalRef.hide();
    localStorage.removeItem('token');
    localStorage.clear();
    this.router.navigate(['/login']);
  }
  
  cancel(){
    this.modalRef.hide();
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/header.component.ts